import { IMaintenance } from 'types/maintenanceInterfaces'
import { SubAPI } from './API'

/**
 * Maintenance API
 * @notExported
 */
class MaintenanceAPI extends SubAPI {
  /**
   * Get maintenances notifications.
   *
   * @returns Array of maintenances notifications.
   */
  public async getMaintenances(controller?: AbortController): Promise<IMaintenance[]> {
    return await this.api.get(`admin/maintenance/`, controller ? { signal: controller.signal } : undefined)
  }

  /**
   * Create a maintenance notification.
   *
   * @param data - Maintenance notification data.
   * @returns Updated or created maintenance notification.
   */
  public async create(data: IMaintenance, controller?: AbortController): Promise<IMaintenance> {
    return await this.api.post(`admin/maintenance/`, data, controller ? { signal: controller.signal } : undefined)
  }

  /**
   * Update a maintenance notification.
   *
   * @param id - Maintenance notification ID.
   * @param data - Maintenance notification data.
   * @returns Updated maintenance notification.
   */
  public async update(id: number, data: IMaintenance, controller?: AbortController): Promise<IMaintenance> {
    return await this.api.put(`admin/maintenance/${id}`, data, controller ? { signal: controller.signal } : undefined)
  }

  /**
   * Delete a maintenance notification.
   *
   * @param id - Maintenance notification ID.
   * @returns Promise of maintenance notification deletion.
   */
  public async delete(id: number, controller?: AbortController): Promise<void> {
    return await this.api.delete(`admin/maintenance/${id}`, controller ? { signal: controller.signal } : undefined)
  }

  /**
   * Get the maintenance status.
   *
   * @returns Maintenance status.
   */
  public async getMaintenanceStatus(controller?: AbortController): Promise<IMaintenance[]> {
    return await this.api.get(`admin/maintenance/status`, controller ? { signal: controller.signal } : undefined)
  }
}

export const maintenanceAPI = new MaintenanceAPI()
